export default {
	SET_SELECTED_CLASS_LEVEL(state, payload) {
		state.selected = payload;
	}
};



// WEBPACK FOOTER //
// ./sources/domains/school/class-level/mutations.js